import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuVisible: false,
    infoDialogVisible: false,
    infoDialogServiceType: '',
    firstClickProgramme: '',
    showRegisterBtn: false,
    menuList: [
      {
        menuItem: '首页',
        path: 'home'
      },
      {
        menuItem: '产品介绍',
        children: [
          { name: '组织人事', path: 'personnelOrganization', icon: 'personnel-organization' },
          { name: '薪酬保险', path: 'salaryInsurance', icon: 'salary-insurance' },
          { name: '绩效管理', path: 'performanceManagement', icon: 'performance-management' },
          { name: '职称评审', path: 'titleReview', icon: 'title-review' },
          { name: '干部管理', path: 'cadreInformation', icon: 'cadre-information' },
          { name: '培养发展', path: 'onlineLearning', icon: 'online-learning' },
          // { name: '人才培养', path: 'onlineLearning', icon: 'online-learning' },
          // { name: '人才发展', path: 'talentDevelopment', icon: 'talent-development' },
          { name: '人才引进', path: 'talentRecruitment', icon: 'talent-recruitment' },
          { name: '员工自助', path: 'employeeSelfService', icon: 'employee-self-service' },
          { name: '经理自助', path: 'managerSelfService', icon: 'manager-self-service' },
          { name: '领导桌面', path: 'leaderDesktop', icon: 'leader-desktop' }
        ],
        path: 'product'
      },
      {
        menuItem: '解决方案',
        children: [
          {
            category: '综合业务解决方案',
            items: [
              { name: '核心人力资源管理', path: 'corePersonnel' },
              { name: '干部管理', path: 'cadreManagement' },
              // { name: '人才项目', path: 'talentProject' },
              { name: '人才管理', path: 'solutionTalentDevelopment' },
            ]
          },
          {
            category: '场景业务解决方案',
            items: [
              // { name: '组织绩效管理', path: 'orgPerformance' },
              { name: '全员绩效管理', path: 'fullPerformance' },
              { name: '360考核', path: 'assessment360' },
              { name: '职称评审', path: 'solutionTitleReview' },
              { name: '同行评议', path: 'peerReview' },
              { name: '民主测评', path: 'democraticEvaluation' },
              { name: '民主推荐', path: 'democraticRecommendation' },
              { name: '领导力评估', path: 'leadershipAssessment' },
              { name: '在线学习与在线考试', path: 'onlineLearningExam' },
              { name: '人才盘点', path: 'talentInventory' },
              { name: '人才地图', path: 'talentMap' },
            ]
          },
          {
            category: '行业业务解决方案',
            items: [
              // { name: '事业单位人才管理', path: 'institutionTalent' },
              { name: '经理层任期制考核', path: 'managerTenure' },
            ]
          },
          {
            category: '技术方案',
            items: [
              { name: '技术解决方案', path: 'securityTechnology' }
            ]
          }
        ],
        path: 'solution'
      },
      {
        menuItem: '合作伙伴',
        path: 'cooperativePartner'
      },
      {
        menuItem: '经典实践',
        path: 'typicalUsers'
      },
      {
        menuItem: '关于我们',
        path: 'aboutUs'
      }
    ]
  },
  getters: {
  },
  mutations: {
    "showMenu": (state, menuVisible) => {
      // console.log(menuVisible)
      state.menuVisible = menuVisible
    },
    "showInfoVisible": (state, infoDialogVisible) => {
      // console.log(menuVisible)
      state.infoDialogVisible = infoDialogVisible
    },
  },
  actions: {
  },
  modules: {
  }
})
